import CheckoutContextProvider from '../../lib/contexts/checkout'
import CheckoutFragment from '../../fragments/checkout'
import { NextSeo } from 'next-seo'
import { getShopConfiguration } from '../../lib/utils'

export default function Checkout() {
  return (
    <>
      <NextSeo title="Checkout" noindex={true} nofollow={true} />
      <CheckoutContextProvider>
        <CheckoutFragment />
      </CheckoutContextProvider>
    </>
  )
}

export async function getServerSideProps({ req }) {
  return await getShopConfiguration(req.locals.config.shop)
}
